import axios from "axios";
import { toast } from "sonner";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Surface permission errors (read-only / pending accounts) as a toast.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 403) {
      toast.error(formatApiError(err.response.data?.detail), { id: "forbidden" });
    }
    return Promise.reject(err);
  }
);

export default api;
